'use client';

import { c as _c } from "react/compiler-runtime";
import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useMediaQuery } from 'usehooks-ts';
import { DialogClose } from '@/components/ui/dialog';
import ViverseButton from '@/components/ViverseButton';
import { cn } from '@/lib/utils';
type ModalCustomHeaderProps = {
  onClearAll: () => void;
  title?: string;
};
export default function ModalCustomHeader(t0) {
  const $ = _c(21);
  const {
    onClearAll,
    title
  } = t0;
  const t = useTranslations();
  const isMobile = useMediaQuery("(max-width: 767px)");
  let t1;
  if ($[0] !== isMobile || $[1] !== t || $[2] !== title) {
    t1 = title ?? (isMobile ? t("worlds-landing.search.filters") : t("worlds-landing.search.genre-and-device"));
    $[0] = isMobile;
    $[1] = t;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const displayTitle = t1;
  let t2;
  if ($[4] !== isMobile) {
    t2 = isMobile && <DialogClose aria-label="close"><X className="size-7 transition-all" /></DialogClose>;
    $[4] = isMobile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isMobile ? "header-5" : "header-3";
  let t4;
  if ($[6] !== t3) {
    t4 = cn(t3, "text-vive-primary-0");
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== displayTitle || $[9] !== t4) {
    t5 = <h3 className={t4}>{displayTitle}</h3>;
    $[8] = displayTitle;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="flex items-center gap-2">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isMobile || $[15] !== onClearAll || $[16] !== t) {
    t7 = <div className="flex items-center gap-4">{isMobile ? <ViverseButton variant="secondary" onClick={onClearAll} className={cn("body-2 hover:text-vive-primary-0 min-w-max transition-all")}>{t("worlds-landing.search.clear-all")}</ViverseButton> : <><button onClick={onClearAll} className="body-2 hover:text-vive-primary-0 transition-all">{t("worlds-landing.search.clear-all")}</button><DialogClose aria-label="close"><X className="size-7 transition-all" /></DialogClose></>}</div>;
    $[14] = isMobile;
    $[15] = onClearAll;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex w-full items-center justify-between">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}